// @flow

export type Country = {
  code: CountryCode,
};

export type CountryCode =
  | 'ar'
  | 'bo'
  | 'br'
  | 'cl'
  | 'co'
  | 'ec'
  | 'mx'
  | 'pe'
  | 'uy'
  | 'py'
  | 'cr'
  | 'pa'
  | 'gt'
  | 'sv'
  | 'do'
;

export const ARGENTINA: Country = {
  code: 'ar',
};

export const BOLIVIA: Country = {
  code: 'bo',
};

export const BRAZIL: Country = {
  code: 'br',
};

export const CHILE: Country = {
  code: 'cl',
};

export const COLOMBIA: Country = {
  code: 'co',
};

export const ECUADOR: Country = {
  code: 'ec',
};

export const MEXICO: Country = {
  code: 'mx',
};

export const PERU: Country = {
  code: 'pe',
};

export const URUGUAY: Country = {
  code: 'uy',
};

export const PARAGUAY: Country = {
  code: 'uy',
};

export const COSTA_RICA: Country = {
  code: 'cr',
};

export const PANAMA: Country = {
  code: 'pa',
};

export const GUATEMALA: Country = {
  code: 'gt',
};

export const EL_SALVADOR: Country = {
  code: 'sv',
};

export const DOMINICAN_REPUBLIC: Country = {
  code: 'do',
};

export const SUPPORTED_COUNTRIES: ImmutableArray<Country> = [
  ARGENTINA,
  BOLIVIA,
  BRAZIL,
  CHILE,
  COLOMBIA,
  ECUADOR,
  MEXICO,
  PERU,
  URUGUAY,
  PARAGUAY,
  COSTA_RICA,
  PANAMA,
  GUATEMALA,
  EL_SALVADOR,
  DOMINICAN_REPUBLIC,
];

export function getCountryFromCode(countryCode: string): Country {
  const country = SUPPORTED_COUNTRIES.find((country: Country) => {
    return country.code === countryCode;
  });

  if (!country) {
    throw new Error(`Unsupported country "${countryCode}"`);
  }

  return country;
}
